// frontend/src/components/dialogs/CancelConfirmDialog.js
import { useState } from 'react';
import { LucideSave, BookX } from 'lucide-react';
import { t } from 'i18next';
import { useTheme } from '../../contexts/ThemeContext';
import ConfirmDialogShell from './ConfirmDialogShell';

export const CancelConfirmDialog = ({ isOpen, onClose, onConfirm }) => {
    const [reason, setReason] = useState('');
    const { components, cn } = useTheme();

    const handleConfirm = () => {
        onConfirm(reason);
        setReason('');
    };

    return (
        <ConfirmDialogShell
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={handleConfirm}
            title={t('cancelTrip')}
            confirmVariant="danger"
            confirmIcon={LucideSave}
            cancelIcon={BookX}
            isDisabled={!reason.trim()}
        >
            <textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder={t('Enter reason for cancellation')}
                className={cn('w-full p-2 rounded mb-4 border', components.input.base, components.input.focus)}
                rows={3}
            />
        </ConfirmDialogShell>
    );
};
export default CancelConfirmDialog;
